import { RouteRecordRaw } from 'vue-router';
import { SectionRouteNames } from './sectionRoutes/sectionRouteNames.ts';

export const deltaGptRoutes: Record<string, RouteRecordRaw> = {
    documentList: {
        path: '',
        name: 'deltaGptDocumentsList',
        component: () => import('@/views/delta-gpt/DocumentsList.vue'),
        meta: {
            headName: 'Documents',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
    subportalRedirect: {
        path: 'document/subportalredirect/:subportalid',
        name: 'deltaGptSubportalRedirect',
        component: () => import('@/views/delta-gpt/SubportalRedirectView.vue'),
        meta: {
            headName: 'Research Redirect',
            searchMeta: {
                noSearch: true,
            },
        },
    },
    documentView: {
        path: 'document/:documentShortCode',
        name: 'deltaGptDocument',
        props: true,
        component: () => import('@/views/delta-gpt/DocumentView.vue'),
        meta: {
            headName: 'Document Viewer',
        },
    },
    sharedView: {
        path: 'share/:shareId',
        name: 'researchReportShare',
        props: true,
        component: () => import('@/views/delta-gpt/SharedDocumentView.vue'),
        meta: {
            headName: 'Document Viewer',
        },
    },
};

export function getResearchRoutes (parentName: SectionRouteNames | string): RouteRecordRaw[] {
    return Object.values(deltaGptRoutes).map(route => ({
        ...route,
        name: route.name ? `${parentName}_${route.name.toString()}` : '',
    }));
}
